export const strCreditKeyLocalStoragePageSize = 'customer-area-credit-page-size';
export const strCreditKeyLocalStorageSort = 'customer-area-credit-sort-favorite';
export const strCreditState = 'customer-area-credit-state';
export const strCurrentTabLink = 'customer-area-invoice-current-tab-link';
export const strInvoiceKeyLocalStoragePageSize = 'customer-area-invoice-page-size';
export const strInvoiceKeyLocalStorageSort = 'customer-area-invoice-sort-favorite';
export const strInvoiceState = 'customer-area-invoice-state';
export const strPeriodSearchTypeFavorite = 'customer-area-invoice-period-search-favorite';
export const strProFormaKeyLocalStoragePageSize = 'customer-area-pro-forma-page-size';
export const strProFormaKeyLocalStorageSort = 'customer-area-pro-forma-sort-favorite';
export const strProFormaState = 'customer-area-pro-forma-state';
